<div class="fui-layout-container">
  <fui-layout-header
    [breadcrumbs]="breadcrumbs"
    [headingText]="this.displayedSection == 'options' ? 'fui-header.support' : 'fui-header.recording_software_hardware_support'"
    [description]="description"
  >
    @if (displayedSection != "options") {
      <div class="fui-nav-pills m-t-30">
        <ul>
          <li>
            <button
              [class.active]="displayedSection == 'articles'"
              (click)="appService.mobileMenuShown = false; switchSection('articles')"
              (keyup.enter)="appService.mobileMenuShown = false; switchSection('articles')"
              (keyup.space)="appService.mobileMenuShown = false; switchSection('articles')"
            >
              Articles
            </button>
          </li>
          <li>
            <button
              [class.active]="displayedSection == 'open'"
              (click)="appService.mobileMenuShown = false; switchSection('open')"
              (keyup.enter)="appService.mobileMenuShown = false; switchSection('open')"
              (keyup.space)="appService.mobileMenuShown = false; switchSection('open')"
            >
              {{ "support.open_tix" | translate }}
            </button>
          </li>
          <li>
            <button
              [class.active]="displayedSection == 'closed'"
              (click)="appService.mobileMenuShown = false; switchSection('closed')"
              (keyup.enter)="appService.mobileMenuShown = false; switchSection('closed')"
              (keyup.space)="appService.mobileMenuShown = false; switchSection('closed')"
            >
              {{ "support.closed_tix" | translate }}
            </button>
          </li>
        </ul>
        <button class="fui-action-btn m-y-5" (click)="createTicket()">
          <fa-icon icon="plus"></fa-icon>
          Create Ticket
        </button>
      </div>
    }
  </fui-layout-header>
  <hr />
  @if (displayedSection == "options") {
    <div class="fui-layout-pad-content">
      <div class="m-t-30">
        <fui-heading [text]="'support.what_would_you_like_support_for' | translate" level="2" fontSize="f5"></fui-heading>
        <ul class="grid-container two-per-row pad-10 m-t-30">
          <li
            [ngStyle]="{ 'min-height': 'unset', 'border-radius': '10px', overflow: 'hidden' }"
            class="exchange-grid-item aspect-16-9"
            tabindex="0"
            (click)="goToFenderSupport()"
            (keyup.enter)="goToFenderSupport()"
            (keyup.space)="goToFenderSupport()"
          >
            <div class="position-relative h-full" role="group" aria-label="support option">
              <img src="./assets/images/hero/fui-hero4.jpg" alt="Instruments, amps and pedals" />
              <div class="d-flex flex-column justify-content-end h-full position-relative">
                <div class="name">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <fui-heading [text]="'support.instruments_amps_pedals_title' | translate" level="3" fontSize="f6" extraClasses="bold creator-title"></fui-heading>
                      <span class="t-12">{{ "support.instruments_amps_pedals_description" | translate }}</span>
                    </div>
                    <fa-icon icon="chevron-right"></fa-icon>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            [ngStyle]="{ 'min-height': 'unset', 'border-radius': '10px', overflow: 'hidden' }"
            class="exchange-grid-item aspect-16-9"
            tabindex="0"
            (click)="switchSection('articles')"
            (keyup.enter)="switchSection('articles')"
            (keyup.space)="switchSection('articles')"
          >
            <div class="position-relative h-full" role="group" aria-label="support option">
              <img src="./assets/images/hero/fui-hero13.jpg" alt="Instruments, amps and pedals" />
              <div class="d-flex flex-column justify-content-end h-full position-relative">
                <div class="name">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <fui-heading [text]="'support.recording_software_hardware_title' | translate" level="3" fontSize="f6" extraClasses="bold creator-title"></fui-heading>
                      <span class="t-12">{{ "support.recording_software_hardware_description" | translate }}</span>
                    </div>
                    <fa-icon icon="chevron-right"></fa-icon>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  }
  @if (displayedSection != "options") {
    <div class="fui-layout-pad-content">
      <ng-container *ngTemplateOutlet="prsSupportOptionSections"></ng-container>
    </div>
  }
  <div class="m-t-100 p-b-50">
    <fui-footer></fui-footer>
  </div>
</div>

<ng-template #prsSupportOptionSections>
  @if (displayedSection == "open") {
    <section class="content-constrained" aria-label="open tickets">
      @if (loadingOpen && !openTickets) {
        <myp-inline-loader [loading]="true" height="200px" spinnerName="openTicketsLoader"></myp-inline-loader>
      }
      @if (openTickets && !openTickets.length) {
        <div class="p-y-50">
          <span>You don’t have any open tickets right now.</span>
          <br />
          <br />
          <span>
            <a href="javascript:void(0);" (click)="switchSection('articles')">Search our knowledgebase</a>
            for common topics and find answers to frequently asked questions.
          </span>
          <br />
          <br />
          <button class="btn btn-primary btn-sm" (click)="createTicket()">Create Ticket</button>
        </div>
      }
      @if (openTickets && openTickets.length) {
        <ul class="list-group p-t-30">
          @for (oTix of openTickets; track oTix) {
            <li class="list-group-item bg-transparent border-0 p-0">
              <div role="group" aria-label="ticket">
                <myp-list-item
                  [title]="oTix.subject"
                  [item]="oTix"
                  [includeChevron]="true"
                  [subData]="['Created: ' + (oTix.created_at | date), 'Updated: ' + (oTix.updated_at | date)]"
                  [showImage]="false"
                  [isLink]="true"
                  (itemClicked)="goToTicket(oTix)"
                >
                  <div class="button-content">
                    <p [class]="'item-status mb-0 ' + oTix.status">
                      <span class="sr-only">status</span>
                      {{ oTix.status | uppercase }}
                    </p>
                  </div>
                </myp-list-item>
              </div>
            </li>
          }
        </ul>
      }
    </section>
  }

  @if (displayedSection == "closed") {
    <section class="content-constrained" aria-label="closed tickets">
      @if (loadingClosed && !closedTickets) {
        <myp-inline-loader [loading]="true" height="200px" spinnerName="closedTicketsLoader"></myp-inline-loader>
      }
      @if (closedTickets && !closedTickets.length) {
        <div class="p-y-50">
          <span>You don’t have any closed tickets right now.</span>
          <br />
          <br />
          <span>
            <a href="javascript:void(0);" (click)="switchSection('articles')">Search our knowledgebase</a>
            for common topics and find answers to frequently asked questions.
          </span>
          <br />
          <br />
          <button class="btn btn-primary btn-sm" (click)="createTicket()">Create Ticket</button>
        </div>
      }
      @if (closedTickets && closedTickets.length) {
        <ul class="list-group p-t-30">
          @for (cTix of closedTickets; track cTix) {
            <li class="list-group-item bg-transparent border-0 p-0">
              <div role="group" aria-label="ticket">
                <myp-list-item
                  [title]="cTix.subject"
                  [item]="cTix"
                  [includeChevron]="true"
                  [subData]="['Created: ' + (cTix.created_at | date), 'Updated: ' + (cTix.updated_at | date)]"
                  [showImage]="false"
                  (itemClicked)="goToTicket(cTix)"
                  [isLink]="true"
                >
                  <div class="button-content">
                    <p [class]="'item-status mb-0 ' + cTix.status">
                      <span class="sr-only">status</span>
                      {{ cTix.status | uppercase }}
                    </p>
                  </div>
                </myp-list-item>
              </div>
            </li>
          }
        </ul>
      }
    </section>
  }

  @if (displayedSection == "rma") {
    <div class="content-constrained">
      <myp-rma></myp-rma>
    </div>
  }
  @if (displayedSection == "articles") {
    <div class="content-constrained">
      <myp-knowledgebase></myp-knowledgebase>
    </div>
  }
</ng-template>
